import React from 'react';
import { useFrame } from '@react-three/fiber';

type Props = {
    doRender: boolean
}

/**
 * This prevents rendering when the 3D view is hidden
 */
export default function RenderConditionally({ doRender }: Props): JSX.Element
{
  useFrame(({ gl, scene, camera }) =>
    doRender && gl.render(scene, camera), 1
  );

  return <></>;
}
